import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ComponentCanDeactivate } from '../../../core/pending-changes.guard';
import { DomainRecordsComponent } from './domain-records/domain-records.component';
import { FormPayload } from '@galaxy/email-ui/sender-chooser';
import { Location } from '@angular/common';

@Component({
  templateUrl: './email-senders.component.html',
  styleUrls: ['./email-senders.component.scss'],
  standalone: false,
})
export class EmailSendersComponent extends ComponentCanDeactivate implements OnInit {
  inputSelection: FormPayload;
  selectorSelection: FormPayload;

  @ViewChild(DomainRecordsComponent) domainRecords: DomainRecordsComponent;

  constructor(
    private readonly activatedRoute: ActivatedRoute,
    private readonly router: Router,
    private readonly location: Location,
    private readonly cd: ChangeDetectorRef,
  ) {
    super();
  }

  handleSenderSelection(event: FormPayload): void {
    if (!event) {
      return;
    }
    this.selectorSelection = event;
    this.cd.detectChanges();
    const tree = this.router.createUrlTree([`email`, `senders`, event.senderType, event.senderId]);
    this.location.go(tree.toString());
  }

  canDeactivate(): boolean {
    if (this.domainRecords) {
      return this.domainRecords.canDeactivate();
    }
    return true;
  }

  ngOnInit(): void {
    const senderTypeFromURL = parseInt(this.activatedRoute.snapshot.params['senderType'], 10);
    const senderIdFromURL = this.activatedRoute.snapshot.params['senderId'];
    if (!!senderTypeFromURL && !!senderIdFromURL) {
      this.inputSelection = { senderType: senderTypeFromURL, senderId: senderIdFromURL };
    }
  }
}
